import ProviderContent from "../content/providerContent";
import Layout from "../layout/Layout";

const Provider = () => {
  return (
    <Layout>
      <ProviderContent />
    </Layout>
  );
};

export default Provider;
